var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('Swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.data),function(item,index){return _c('SwiperSlide',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),1),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }